import { render, staticRenderFns } from "./ProdutoUpdate.vue?vue&type=template&id=68db23c6"
import script from "./ProdutoUpdate.vue?vue&type=script&lang=js"
export * from "./ProdutoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports